module.exports = "/_next/static/images/mg-9dc1916f66c0290c328a1f57faff4d6c.svg";